module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cdb526cf25d15942e9db8cc2eb73c28b.png";